const german = {
  name: "German",
  native_name: "Deutsch",
  code: "de",
};

const de = {
  translation: {
    report_bug: "Einen Fehler melden",
    import: "Importieren",
    file: "Datei",
    new: "Neu",
    new_window: "Neues Fenster",
    open: "Öffnen",
    save: "Speichern",
    save_as: "Speichern unter",
    save_as_template: "Als Vorlage speichern",
    template_saved: "Vorlage gespeichert!",
    rename: "Umbenennen",
    delete_diagram: "Diagramm löschen",
    are_you_sure_delete_diagram:
      "Möchten Sie dieses Diagramm wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    oops_smth_went_wrong: "Hoppla! Etwas ist schief gelaufen.",
    import_diagram: "Diagramm importieren",
    import_from_source: "Von SQL importieren",
    export_as: "Exportieren als",
    export_source: "SQL exportieren",
    models: "Modelle",
    exit: "Beenden",
    edit: "Bearbeiten",
    undo: "Rückgängig",
    redo: "Wiederherstellen",
    clear: "Leeren",
    are_you_sure_clear:
      "Möchten Sie das Diagramm wirklich leeren? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    cut: "Ausschneiden",
    copy: "Kopieren",
    paste: "Einfügen",
    duplicate: "Duplizieren",
    delete: "Löschen",
    copy_as_image: "Als Bild kopieren",
    view: "Ansicht",
    header: "Menüleiste",
    sidebar: "Seitenleiste",
    issues: "Probleme",
    presentation_mode: "Präsentationsmodus",
    strict_mode: "Strikter Modus",
    field_details: "Angaben zum Feld",
    reset_view: "Ansicht zurücksetzen",
    show_grid: "Gitter anzeigen",
    show_cardinality: "Kardinalität anzeigen",
    theme: "Motiv",
    light: "Hell",
    dark: "Dunkel",
    zoom_in: "Heranzoomen",
    zoom_out: "Herauszoomen",
    fullscreen: "Vollbild",
    settings: "Einstellungen",
    show_timeline: "Zeitleiste anzeigen",
    autosave: "Automatisch speichern",
    panning: "Verschieben",
    table_width: "Tabellenbreite",
    language: "Sprache",
    flush_storage: "Speicher leeren",
    are_you_sure_flush_storage:
      "Sind Sie sicher, dass Sie den Speicher leeren wollen? Dadurch werden alle Ihre Diagramme und benutzerdefinierten Vorlagen unwiderruflich gelöscht.",
    storage_flushed: "Speicher geleert",
    help: "Hilfe",
    shortcuts: "Tastenkürzel",
    ask_on_discord: "Fragen Sie uns auf Discord",
    feedback: "Feedback",
    no_changes: "Keine Änderungen",
    loading: "Laden...",
    last_saved: "Zuletzt gespeichert",
    saving: "Speichern...",
    failed_to_save: "Speichern fehlgeschlagen",
    fit_window_reset: "Fenster anpassen / Zurücksetzen",
    zoom: "Zoom",
    add_table: "Tabelle hinzufügen",
    add_area: "Bereich hinzufügen",
    add_note: "Notiz hinzufügen",
    add_type: "Typ hinzufügen",
    to_do: "Zu erledigen",
    tables: "Tabellen",
    relationships: "Beziehungen",
    subject_areas: "Themengebiete",
    notes: "Notizen",
    types: "Typen",
    search: "Suchen...",
    no_tables: "Keine Tabellen",
    no_tables_text: "Beginnen Sie mit dem Aufbau Ihres Diagramms!",
    no_relationships: "Keine Beziehungen",
    no_relationships_text: "Ziehen Sie, um Felder zu verbinden und Beziehungen herzustellen!",
    no_subject_areas: "Keine Themenbereiche",
    no_subject_areas_text: "Fügen Sie Themenbereiche zu Gruppentabellen hinzu!",
    no_notes: "Keine Notizen",
    no_notes_text: "Fügen Sie Notizen hinzu, um Ihr Diagramm zu kommentieren!",
    no_types: "Keine Typen",
    no_types_text: "Fügen Sie benutzerdefinierte Typen hinzu!",
    no_issues: "Keine Probleme gefunden.",
    strict_mode_is_on_no_issues:
      "Der strenge Modus ist ausgeschaltet, es werden keine Probleme angezeigt.",
    name: "Name",
    type: "Typ",
    null: "Null",
    not_null: "Nicht Null",
    primary: "Primär",
    unique: "Einzigartig",
    autoincrement: "Autoinkrement",
    default_value: "Standardwert",
    check: "Ausdruck prüfen",
    this_will_appear_as_is: "*Dies wird im generierten Skript so erscheinen.",
    comment: "Kommentar",
    add_field: "Feld hinzufügen",
    values: "Werte",
    size: "Größe",
    precision: "Präzision",
    set_precision: "Präzision festlegen: (Größe, Ziffern)",
    use_for_batch_input: "Verwenden Sie , für Batch-Input",
    indices: "Indizes",
    add_index: "Index hinzufügen",
    select_fields: "Felder auswählen",
    title: "Titel",
    not_set: "Nicht festgelegt",
    foreign: "Fremd",
    cardinality: "Kardinalität",
    on_update: "Beim Aktualisieren",
    on_delete: "Beim Löschen",
    swap: "Tauschen",
    one_to_one: "Eins zu eins",
    one_to_many: "Eins zu viele",
    many_to_one: "Viele zu eins",
    content: "Inhalt",
    types_info:
      "Diese Funktion ist für objekt-relationale DBMS wie PostgreSQL gedacht.\n" +
      "Bei Verwendung für MySQL oder MariaDB wird ein JSON-Typ mit der entsprechenden JSON-Validierungsprüfung erzeugt.\n" +
      "Bei Verwendung für SQLite wird es in ein BLOB übersetzt.\n" +
      "Bei der Verwendung für MSSQL wird ein Typ-Alias für das erste Feld erzeugt.",
    table_deleted: "Tabelle gelöscht",
    area_deleted: "Bereich gelöscht",
    note_deleted: "Notiz gelöscht",
    relationship_deleted: "Beziehung gelöscht",
    type_deleted: "Typ gelöscht",
    cannot_connect: "Kann nicht verbinden, die Spalten haben unterschiedliche Typen",
    copied_to_clipboard: "In die Zwischenablage kopiert",
    create_new_diagram: "Neues Diagramm erstellen",
    cancel: "Abbrechen",
    open_diagram: "Diagramm öffnen",
    rename_diagram: "Diagramm umbenennen",
    export: "Exportieren",
    export_image: "Bild exportieren",
    create: "Erstellen",
    confirm: "Bestätigen",
    last_modified: "Zuletzt geändert",
    drag_and_drop_files: "Ziehen Sie die Datei hierher oder klicken Sie, um sie hochzuladen.",
    support_json_and_ddb: "JSON- und DDB-Dateien werden unterstützt",
    upload_sql_to_generate_diagrams:
      "Laden Sie eine SQL-Datei hoch, um Ihre Tabellen und Spalten automatisch zu generieren.",
    overwrite_existing_diagram: "Vorhandenes Diagramm überschreiben",
    only_mysql_supported:
      "*Vorläufig wird nur das Laden von MySQL-Skripten unterstützt.",
    blank: "Leer",
    filename: "Dateiname",
    table_w_no_name: "Eine Tabelle ohne Namen wurde deklariert",
    duplicate_table_by_name: "Doppelte Tabelle mit dem Namen '{{tableName}}'",
    empty_field_name: "Leeres Feld `name` in der Tabelle '{{tableName}}'",
    empty_field_type: "Leeres Feld `type` in der Tabelle '{{tableName}}'",
    no_values_for_field:
      "Das Feld '{{fieldName}}' der Tabelle '{{tableName}}' ist vom Typ `{{type}}`, aber es wurden keine Werte angegeben",
    default_doesnt_match_type:
      "Der Standardwert für das Feld '{{fieldName}}' in der Tabelle '{{tableName}}' entspricht nicht seinem Typ",
    not_null_is_null:
      "Das Feld '{{fieldName}}' der Tabelle '{{tableName}}' ist NOT NULL, hat aber standardmäßig NULL",
    duplicate_fields:
      "Doppelte Tabellenfelder mit dem Namen '{{fieldName}}' in der Tabelle '{{tableName}}'",
    duplicate_index:
      "Doppelter Index mit dem Namen '{{indexName}}' in der Tabelle '{{tableName}}'",
    empty_index: "Der Index in Tabelle '{{tableName}}' indiziert keine Spalten",
    no_primary_key: "Tabelle '{{Tabellenname}}' hat keinen Primärschlüssel",
    type_with_no_name: "Ein Typ ohne Namen wurde deklariert",
    duplicate_types: "Doppelte Typen mit dem Namen '{{typeName}}'",
    type_w_no_fields: "Ein leerer Typ '{{typeName}}' ohne Felder wurde deklariert",
    empty_type_field_name: "Leeres Feld `name` im Typ '{{typeName}}'",
    empty_type_field_type: "Leeres Feld `type` im Typ '{{typeName}}'",
    no_values_for_type_field:
      "Das Feld '{{fieldName}}' des Typs '{{typeName}}' ist vom Typ `{{type}}`, aber es wurden keine Werte angegeben",
    duplicate_type_fields:
      "Doppelte Typfelder mit dem Namen '{{fieldName}}' im Typ '{{typeName}}'",
    duplicate_reference: "Doppelte Referenz mit dem Namen '{{refName}}'",
    circular_dependency: "Zirkuläre Abhängigkeit, die Tabelle '{{refName}}' betrifft",
    timeline: "Zeitleiste",
    priority: "Priorität",
    none: "Keine",
    low: "Niedrig",
    medium: "Mittel",
    high: "Hoch",
    sort_by: "Sortieren nach",
    my_order: "Meine Reihenfolge",
    completed: "Abgeschlossen",
    alphabetically: "Alphabetisch",
    add_task: "Aufgabe hinzufügen",
    details: "Details",
    no_tasks: "Sie haben noch keine Aufgaben.",
    no_activity: "Sie haben noch keine Aktivitäten.",
    move_element: "{{name}} nach {{coords}} verschieben",
    edit_area: "{{extra}} Bereich {{areaName}} bearbeiten",
    delete_area: "Bereich {{areaName}} löschen",
    edit_note: "{{extra}} Notiz {{noteTitle}} bearbeiten",
    delete_note: "Notiz {{noteTitle}} löschen",
    edit_table: "{{extra}} Tabelle {{tableName}} bearbeiten",
    delete_table: "Tabelle {{tableName}} löschen",
    edit_type: "{{extra}} Typ {{typeName}} bearbeiten",
    delete_type: "Typ {{typeName}} löschen",
    add_relationship: "Beziehung hinzufügen",
    edit_relationship: "{{extra}} Beziehung {{refName}} bearbeiten",
    delete_relationship: "Beziehung {{refName}} löschen",
    not_found: "Nicht gefunden",
  },
};

export { de, german };
